import { QueryClient } from '@tanstack/react-query';

// The one place the client's defaults live. The browser regression that
// mounts the real App (tests/entry, BL-596) builds its client here too, so
// what it proves about retries and settling is proved against exactly the
// numbers the product ships with — a suite showing "this does not loop" on
// different defaults would show nothing.
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });
}
